export default "__VITE_ASSET__CnJMU5LV__"